import { Hidden }                   from "@material-ui/core";
import * as React                   from "react";
import { FC }                       from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card }                     from "semantic-ui-react";
import Account                      from "../../../../domain/account/Account";
import AccountRoleType              from "../../../../domain/account/AccountRoleType";
import { ResKaState }               from "../../../../index";
import RouterDispatcher             from "../../../../infrastructure/redux/router/RouterDispatcher";

const ReservationSettingButton: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  switch (account.role.value) {
    default:
      return null;
    case AccountRoleType.CORPORATION:
    case AccountRoleType.OFFICE:
    case AccountRoleType.STAFF:
      if (account.options.hasReservation()) {
        return (
          <>
            <Hidden smDown={ true }>
              <Card onClick={ () => routerDispatcher.reservationSetting() }>
                <Card.Content>
                  <Card.Header>予約の設定をする</Card.Header>
                  <Card.Description>
                    予約を受け付ける時間帯と施設または設備を登録することができます。
                  </Card.Description>
                </Card.Content>
              </Card>
            </Hidden>

            <Hidden mdUp={ true }>
              <Card onClick={ () => routerDispatcher.reservationSetting() }>
                <Card.Content>
                  <Card.Header>予約の設定をする</Card.Header>
                </Card.Content>
              </Card>
            </Hidden>
          </>
        );
      }
      return null;
  }
};

export default ReservationSettingButton;
